<template>
  <div>
    <!-- begin image src with "./" so it's imported as a vue 'static asset' -->
    <!-- https://cli.vuejs.org/guide/html-and-static-assets.html#static-assets-handling -->
    <a href="https://dornsife.usc.edu/bridge-institute/" target="_blank">
      <img
        v-if="displayWidth === 'narrow'"
        class="short"
        src="./img/Bridge-small.png"
        alt="USC Bridge Institute"
        title="USC Bridge Institute" />
      <img
        v-else
        class="long"
        src="./img/Bridge.png"
        alt="USC Bridge Institute"
        title="USC Bridge Institute" />
      <!-- Bridge-lightMode.png | Bridge.png -->
    </a>
  </div>
</template>

<script setup>
import {inject} from "vue";
// seems more robust that using the style/CSS below
const displayWidth = inject("displayWidth"); // from composable/display.js
</script>

<style scoped>
img {
  height: auto;
  width: auto;
  max-width: none;
  vertical-align: text-top;
  transform: scale(1.25);
  transform-origin: left center;
}
</style>
